import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {EcommerceService} from "../../websites/website/ecommerce/ecommerce.service";
import {LoadEcommerceRefunds} from "../actions";
import * as EcommerceRefundsAction from '../actions/ecommerce-refunds.action';

@Injectable()
export class EcommerceRefundsEffect {

  loadEcommerceRefunds = createEffect(() => this._actions$.pipe(
    ofType(EcommerceRefundsAction.LOAD_ECOMMERCE_REFUNDS),
    mergeMap((action: LoadEcommerceRefunds) => {
      const websiteId = action.payload.websiteId;
      const orderId = action.payload.orderId;
      return this._ecommerceService.getOrderRefunds(websiteId, orderId)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response?.data?.dataKey) {
              return new EcommerceRefundsAction.LoadEcommerceRefundsSuccess({
                data: response?.data?.dataKey,
                websiteId: websiteId,
                orderId: orderId,
                loaded: true
              });
            }
            return new EcommerceRefundsAction.LoadEcommerceRefundsFail({websiteId});
          })
        );
    })
  ));



  constructor(
    private _actions$: Actions,
    private _ecommerceService: EcommerceService,
  ) {
  }

}
